import React, { Component } from 'react';
import { usePromiseTracker } from "react-promise-tracker";
import LinearProgress from '@material-ui/core/LinearProgress';

export const LoadingBar = (props) => {
    const { promiseInProgress } = usePromiseTracker();

    return (
        <div>
            {
                (promiseInProgress === true) ?
                    <LinearProgress color='secondary'/>
                    :
                    null
            }
        </div>
    )
};

export default (LoadingBar);